import reducers from './reducers';
import settingsAction from './actions';

const settingsReducers = {
  appInfo: reducers.appInfoReducer,
  appInvites: reducers.appPendingInvitesReducer,
};

export { settingsAction, settingsReducers };
